import React, { useState, useEffect } from "react";

import PropTypes from "prop-types";

// page index start with 0
const PaginationV2 = (props) => {
    const [totalPage, setTotalPage] = useState(0);
    const [pages, setPages] = useState([1]);
    useEffect(() => {
        calculatePagingInfo();
    }, [props]);

    const calculatePagingInfo = () => {
        let totalPage = Math.ceil(props.total / props.perPage);
        let showStartPage = props.currentPage - 4;
        let showEndPage = props.currentPage + 4;
        let pages = [];
        if(showEndPage > totalPage) {
            showStartPage -= (showEndPage - totalPage + 1);
            showEndPage = totalPage;
        }
        if(showStartPage < 0) {
            showEndPage += (-showStartPage);
            showStartPage = 0;
        }
        for (let i = showStartPage; i <= showEndPage; i++) {
            if (i >= totalPage) {
                break;
            }
            pages.push(i);
        }
        setTotalPage(totalPage);
        setPages(pages);
    };

    const goPage = (pageValue) => {
        let page = 0;
        if (Number.isInteger(pageValue)) {
            page = pageValue;
        } else {
            if (pageValue == "first") {
                page = 0;
            } else if (pageValue == "last") {
                page = totalPage - 1;
            } else if (pageValue == "prev") {
                page = props.currentPage - 1;
            } else if (pageValue == "next") {
                page = props.currentPage + 1;
            } else {
                console.error(`page argument error - ${pageValue}`);
                return;
            }
        }
        if (page < 0) page = 0;
        if (page > totalPage - 1) page = totalPage - 1;

        if (page != props.currentPage && page >= 0 && page <= totalPage - 1) {
            if (props.callback) props.callback(page);
        }
    };
    const screenWidth = window.innerWidth;
    let showSibling = 4;
    if(screenWidth < 480) {
        showSibling = 1;
    // } else if(screenWidth < 576) {
    //     showSibling = 2;
    } else if(screenWidth < 950) {
        showSibling = 3;
    }
    return (
        <>
            <nav aria-label="Page navigation">
                <ul className="pagination">
                    <li className="page-item">
                        <a className="page-link" onClick={() => goPage("first")} aria-label="처음">
                            <i className="fas fa-angle-double-left"></i>
                            <span className="sr-only">처음</span>
                        </a>
                    </li>
                    <li className="page-item">
                        <a className="page-link" onClick={() => goPage("prev")} aria-label="Previous">
                            <i className="fas fa-angle-left"></i>
                            <span className="sr-only">이전</span>
                        </a>
                    </li>
                    {pages.map((p) => {
                        return (
                            <li key={p} className={`page-item ${p === props.currentPage ? "active" : ((p >= props.currentPage - showSibling && p <= props.currentPage + showSibling) ? "" : "page-item-faraway")}`}>
                                <a className={"page-link"} onClick={() => goPage(p)}>
                                    {p + 1}
                                </a>
                            </li>
                        );
                    })}
                    <li className="page-item">
                        <a className="page-link" onClick={() => goPage("next")} aria-label="Next">
                            <i className="fas fa-angle-right"></i>
                            <span className="sr-only">다음</span>
                        </a>
                    </li>
                    <li className="page-item">
                        <a className="page-link" onClick={() => goPage("last")} aria-label="Next">
                            <i className="fas fa-angle-double-right"></i>
                            <span className="sr-only">끝</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </>
    );
};

PaginationV2.propTypes = {
    perPage: PropTypes.number,
    maxShowPage: PropTypes.number,
    total: PropTypes.number,
    callback: PropTypes.func,
};

export default PaginationV2;
